import { publicPage } from './getVisitorSheetList'
import { deepClone } from '@/assets/js/utils'
import { answerSettleAdjust, settlementCreate, getAnswerInterviewers } from '@/api/wenjuan/settlement'
import { visitorSheetListOptions } from './options'
import { visitorSheetListSearchFields } from './search'
import { getVisitorSheetList } from '@/api/wenjuan/settlement'
import GlobalConfig from '@/global/config'

let index = 0 // 游标 这个游标不能放到 data 数据中 因为会导致表格合并无限循环

export default {
  props: {
    // queryForm: {
    //   type: Object,
    //   default: () => ({})
    // }
    settleType: {
      // 0=委托方页面,1=代理页面,2=面访页面
      type: Number,
      default: 2
    }
  },
  data() {
    return {
      forms: {
        settleStatus: 0, //结算状态
        executorIds: [], // 调查员姓名/联系方式
        jobExecutionName: '' //任务名称
      },
      searchField: visitorSheetListSearchFields,
      option: visitorSheetListOptions,
      queryFields: [],
      settlementId: '',
      drawer: false,
      sentData: {},
      dialogSettlementBillTitle: '生成结算单确认',
      dialogSettlementBillVisible: false,
      dialogTitle: '调整单价',
      dialogVisible: false,
      dialogUnitPrice: '',
      dialogType: '',
      sheetNum: 0,
      sheetAmountSum: 0,
      totalYuanAmount: 0,
      visitorNum: 0,
      taskNum: 0,
      dialogForm: {
        realAmount: '',
        adjustDescribe: ''
      },
      rules: {
        realAmount: [
          { required: true, message: '请输入金额', trigger: 'blur' },
          {
            pattern: /^([1-9]\d{0,9}|0)(\.\d{1,2})?$/,
            message: '请输入有效的的金额'
          }
        ],
        adjustDescribe: [
          { required: true, message: '请输入内容', trigger: 'blur' },
          { min: 2, max: 20, message: '长度在 2 到 20 个字符', trigger: 'blur' }
        ]
      },
      selectionList: [], //选中id列表
      selected: [], // 选中对象列表
      selectionAmountList: [],
      selectionSingleAmountList: [],
      statusFlag: true,
      page: publicPage,
      data: [],
      // 按照什么字段合并
      combineField: {
        name: 'executorPhone',
        concat: 'executorPhone',
        id: 'id'
      },
      spanArr: [], // 合并数组
      pos: [], // 标志哪个位置开始合并
      preAllInterviewerIdsStatus: [],
      curAllKeysItems: [],
      selectionChangeFlag: false
    }
  },
  methods: {
    //全部结算
    toSettlementAll() {
      this.$confirm('确定全部结算吗？', '确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        customClass: 'confirm-box',
        showClose: false,
        type: 'warning'
      })
        .then(() => {
          const fs = deepClone(this.forms)
          fs.surveyId = GlobalConfig.getSurveyId()
          fs.settleType = this.settleType
          settlementCreate(fs)
            .then(res => {
              this.commonChange()
              this.$message({
                showClose: true,
                message: '生成成功',
                type: 'success'
              })
              this.toSettlementBillList()
            })
            .catch(err => {
              this.$message({
                showClose: true,
                message: '生成失败',
                type: 'error'
              })
            })
        })
        .catch(() => {})
    },
    openDrawer(row) {
      this.settlementId = row.statementId
      this.drawer = true
      this.$nextTick(function () {
        this.$refs.detailDrawer.getSettlementDetail()
      })
    },
    generateSettlementBill() {
      if (this.selectionList.length == 0) {
        this.$message.error('未选择答卷')
        return
      }
      if (!this.statusFlag) {
        this.$message.error('含有“无未结算”状态的任务，请筛选为“有未结算”后再进行操作。')
        return
      }
      this.dialogSettlementBillVisible = true
    },
    createSettlement() {
      let params = {
        settleType: this.settleType,
        surveyId: GlobalConfig.getSurveyId(),
        jobExecutionIds: this.selectionList
      }
      settlementCreate(params)
        .then(res => {
          this.dialogSettlementBillVisible = false
          this.commonChange()
          this.$message({
            showClose: true,
            message: '生成成功',
            type: 'success'
          })
          this.toSettlementBillList()
        })
        .catch(err => {
          this.$message({
            showClose: true,
            message: '生成失败',
            type: 'error'
          })
        })
    },
    toSettlementBillList() {
      let pathStr = ''
      if (this.settleType === 0) {
        pathStr = 'proxy'
      } else if (this.settleType === 1) {
        pathStr = 'visitor'
      } else if (this.settleType === 2) {
        pathStr = 'offline'
      } else if (this.settleType === 3) {
        pathStr = 'phone'
      }
      this.$router.push({
        path: '/survey/' + GlobalConfig.getSurveyId() + '/settlement/settlement-' + pathStr + '/list',
        query: {
          settleType: this.settleType
        }
      })
    },
    showDialog(row, bach) {
      console.log('row', row)
      if (bach == 'bach') {
        this.dialogTitle = '批量调价'
        let array = [...new Set(this.selectionSingleAmountList)]
        this.dialogUnitPrice = array.join(',')
        this.dialogType = 'bach'
      } else if (bach == 'all') {
        this.dialogTitle = '全部调价'
        this.dialogType = 'all'
      } else {
        this.dialogTitle = '调整单价'
        this.dialogUnitPrice = row.executionSingleAmount
        this.dialogType = 'single'
      }
      this.dialogVisible = true
      let data = {
        settleType: this.settleType,
        surveyId: GlobalConfig.getSurveyId(),
        jobExecutionIds: [row.id]
      }
      // 是否批量
      if (bach == 'bach') {
        data.jobExecutionIds = this.selectionList
      } else if (bach == 'all') {
        data.jobExecutionIds = []
      }
      this.sentData = data
    },
    showDialogBatch(bach) {
      if (bach == 'bach') {
        if (this.selectionList.length > 0) {
          this.showDialog({}, bach)
        } else {
          this.$message.error('批量操作前请先进行选择')
        }
      } else if (bach == 'all') {
        this.showDialog({}, bach)
      }
    },
    handleClose() {
      this.dialogVisible = false
      this.$refs['dialogForm'].clearValidate()
      Object.assign(this.$data.dialogForm, this.$options.data().dialogForm)
    },
    handleSettlementBillClose() {
      this.dialogSettlementBillVisible = false
    },
    select(val,row) {
      // console.log('666',val)
      // console.log('6667',row)
      let obj= val.find(v=>v.id == row.id)
      let newVal
      if(!obj) {
        newVal = val.filter(v=>v.executorPhone != row.executorPhone)
        this.$refs.tableRef.clearSelection()
        newVal.forEach(i => {
          this.$refs.tableRef.toggleRowSelection(i,true)
        })
      } else {
        newVal = val.filter(v=>v.executorPhone != row.executorPhone)
        this.data.forEach(i => {
          if(i.executorPhone == row.executorPhone) {
            newVal.push(i)
          }
        })
        this.$refs.tableRef.clearSelection()
        newVal.forEach(i => {
          this.$refs.tableRef.toggleRowSelection(i,true)
        })
      }
      this.selectAll(newVal)
    },
    selectAll(val) {
      //console.log('9999999',val)
      this.statusFlag = true
      let temlist = []
      // let hash = {}
      // val = val.reduce((item, next) => {
      //   if(!hash[next.executorPhone]) {
      //     hash[next.executorPhone] = true
      //     item.push(next)
      //   }
      //   return item
      // }, [])
      // val.forEach(item => {
      //   this.data.forEach(i => {
      //     if(i.executorPhone == item.executorPhone) {
      //       temlist.push(i)
      //     }
      //   })
      // })
      temlist = val
      this.selectionList = temlist.map(el=>{
        if(el.settleStatus != 0) {
          this.statusFlag = false
        }
        return el.id
      })
      this.selected = temlist
      let num = 0
      let i =0
      let num2 = 0
      let selectionVisitorList = []
      this.selectionSingleAmountList = []
      this.selectionAmountList = temlist.map(el=>{
        selectionVisitorList.push(el.executorPhone)
        this.selectionSingleAmountList.push(el.executionSingleAmount)
        num = num + Number(el.totalRealYuanAmount)
        num2 = num2 + Number(el.notInitiatedQuantity)
        i++
        return el.realYuanAmount
      })
      this.sheetAmountSum = num.toFixed(2)
      this.sheetNum = num2
      this.taskNum = i
      this.visitorNum = [...new Set(selectionVisitorList)].length
      console.log('this.selectionList',this.selectionList);
      console.log('this.selected',this.selected);
    },
    SelectionChange(val){
      if(this.selectionChangeFlag){
        this.selectionList = val.map(el=>{
          if(el.settleStatus != 0) {
            this.statusFlag = false
          }
          return el.id
        })
        this.selected = val
        console.log('this.selectionList1',this.selectionList);
        console.log('this.selected1',this.selected);
        this.selectionChangeFlag=false
      }
      
      // this.statusFlag = true
      // let temlist = []
      // let hash = {}
      // console.log('6666699', val)
      // val = val.reduce((item, next) => {
      //   if(!hash[next.executorPhone]) {
      //     hash[next.executorPhone] = true
      //     item.push(next)
      //   }
      //   return item
      // }, [])
      // val.forEach(item => {
      //   this.data.forEach(i => {
      //     if(i.executorPhone == item.executorPhone) {
      //       temlist.push(i)
      //     }
      //   })
      // })
      // this.selectionList = temlist.map(el=>{
      //   if(el.settleStatus != 0) {
      //     this.statusFlag = false
      //   }
      //   return el.id
      // })
      // let num = 0
      // let i =0
      // let num2 = 0
      // let selectionVisitorList = []
      // this.selectionSingleAmountList = []
      // this.selectionAmountList = temlist.map(el=>{
      //   selectionVisitorList.push(el.executorPhone)
      //   this.selectionSingleAmountList.push(el.executionSingleAmount)
      //   num = num + Number(el.totalRealYuanAmount)
      //   num2 = num2 + Number(el.notInitiatedQuantity)
      //   i++
      //   return el.realYuanAmount
      // })
      // this.sheetAmountSum = num.toFixed(2)
      // this.sheetNum = num2
      // this.taskNum = i
      // this.visitorNum = [...new Set(selectionVisitorList)].length
      // console.log('this.selectionList',this.selectionList);
    },
    // 问卷调价
    editMoney() {
      this.$refs['dialogForm'].validate(valid => {
        if (valid) {
          let data = this.sentData
          data.realYuanAmount = this.dialogForm.realAmount
          data.adjustDescribe = this.dialogForm.adjustDescribe
          answerSettleAdjust(data)
            .then(res => {
              this.dialogVisible = false
              Object.assign(this.$data.dialogForm, this.$options.data().dialogForm)
              this.$refs.tableRef.clearSelection()
              this.sheetAmountSum = 0
              this.commonChange()
              this.$message({
                showClose: true,
                message: '调价成功',
                type: 'success'
              })
            })
            .catch(err => {
              this.$message({
                showClose: true,
                message: '调价失败',
                type: 'error'
              })
            })
        } else {
          return false
        }
      })
    },
    // 获取列表
    getList(params) {
      this.loading = true
      getVisitorSheetList(params)
        .then(res => {
          this.totalYuanAmount = Number(res.data.data.totalYuanAmount).toFixed(2)
          if (params.settleStatus == 0) {
            this.total = res.data.data.total
          } else {
            this.total = 0
          }
          this.page.total = res.data.data.total
          this.page.currentPage = res.data.data.current
          this.page.pageSize = res.data.data.size
          this.data = res.data.data.records
          this.data.forEach(item => {
            let sign = ''
            if (item.realMinYuanAmount) {
              if (item.realMinYuanAmount == item.realMaxYuanAmount) {
                item.realYuanAmount = item.realMinYuanAmount.toFixed(2)
              } else {
                item.realYuanAmount = item.realMinYuanAmount.toFixed(2) + ' - ' + item.realMaxYuanAmount.toFixed(2)
              }
            } else {
              item.realYuanAmount = ''
            }
            if (item.adjustMinYuanAmount) {
              if (item.adjustMinYuanAmount || item.adjustMaxYuanAmount) {
                if (item.adjustMinYuanAmount == item.adjustMaxYuanAmount) {
                  if (item.realYuanAmount > item.executionSingleAmount) {
                    sign = '+'
                  }
                  item.adjustYuanAmount = sign + item.adjustMinYuanAmount.toFixed(2)
                } else {
                  // item.adjustYuanAmount = item.adjustMinYuanAmount.toFixed(2) + ' - ' +  item.adjustMaxYuanAmount.toFixed(2)
                  item.adjustYuanAmount = ''
                }
              } else {
                item.adjustYuanAmount = ''
              }
            } else {
              item.adjustYuanAmount = ''
            }
            // item.singleAmount = Number(item.singleAmount)?(Number(item.singleAmount)/100).toFixed(2):Number(item.singleAmount).toFixed(2)
            // item.realAmount = Number(item.realAmount)?(Number(item.realAmount)/100).toFixed(2):Number(item.realAmount).toFixed(2)
            // if (item.adjustAmount && item.adjustAmount != '0') {
            //   let sign = item.adjustAmount.substring(0, 1)
            //   let adjustAmountReal = item.adjustAmount.substring(1)
            //   item.adjustAmount = sign + (Number(adjustAmountReal)/100).toFixed(2)
            // } else {
            //   item.adjustAmount = ''
            // }
          })
          this.combineData()
          // 如果当前查询页数 没有数据 往前一页查询一次
          if (this.data.length === 0 && this.page.currentPage != 1) {
            this.page.currentPage--
            if (this.page.currentPage > 0) {
              params.current = this.page.currentPage
              getList(params)
            }
          }
          this.loading = false
        })
        .catch(err => {
          console.log(err)
          // return err
        })
    },
    // 整理请求数据
    handleData() {
      const fs = deepClone(this.forms)
      fs.current = this.page.currentPage
      fs.size = this.page.pageSize
      fs.surveyId = GlobalConfig.getSurveyId()
      fs.settleType = this.settleType
      // Object.keys(params).forEach((key) => {
      //   // 0 不删除
      //   if (!params[key] && params[key] !== 0) {
      //     delete params[key]
      //   }
      // })
      return fs
    },
    commonChange() {
      this.getList(this.handleData())
      this.$emit('refreshHead')
    },
    onChangeSearchField(params) {
      if (params.executorIds) {
        params.executorIds = params.executorIds.join(',')
      }
      if (params.auditTimeMin) {
        params.auditTimeBegin = params.auditTimeMin
        delete params.auditTimeMin
      }
      if (params.auditTimeMax) {
        params.auditTimeEnd = params.auditTimeMax
        delete params.auditTimeMax
      }
      this.forms = params
      this.page.currentPage = 1
      this.commonChange()
    },
    // 点击 每页显示条数 触发
    sizeChange(val) {
      this.page.currentPage = 1
      this.page.pageSize = val
      //   重新渲染
      this.commonChange()
    },
    // 切换页面 （点击页码、数字、输入数字） 触发
    currentChange(val) {
      this.savePreAllInterviewerIdsStatus()
      this.page.currentPage = val
      //   重新渲染
      this.commonChange()
    },
    init() {
      this.page = {
        total: 0, // 总页数
        currentPage: 1, // 当前页数
        pageSize: 20, // 每页显示多少条
        pageSizes: [10, 20, 30, 50, 100]
      }
      this.commonChange()
    },
    getAnswerInterviewers() {
      let params = {
        surveyId: GlobalConfig.getSurveyId(),
        settleType: this.settleType
      }
      getAnswerInterviewers(params)
        .then(res => {
          let data = res.data.data
          this.searchField[1].options = data.map(item => {
            let opItem = {}
            opItem.label = item.name || item.phone
            opItem.value = item.id
            return opItem
          })
          this.queryFields = deepClone(this.searchField)
        })
        .catch(err => {})
    },
    // 判断哪些数据可以合并起来的逻辑函数
    combineData() {
      // 下面的这几个都需要重置 因为在变换页码时 如果是之前的东西 会导致表格错乱
      index = 0
      this.pos = []
      this.spanArr = []
      this.curAllKeysItems = []
      // 判断哪几条数据可以合并
      let count = 1 // 起计数作用 计算几行进行合并
      for (let i = 0; i < this.data.length; i++) {
        if (i === 0) {
          if (this.data[i][this.combineField.name] !== null) {
            this.pos.push([0, [this.data[i][this.combineField.name]]])
          } else {
            this.pos.push([0, ['']])
          }
          this.curAllKeysItems.push(this.data[0])
        } else {
          if (this.data[i][this.combineField.concat] == this.data[i - 1][this.combineField.concat]) {
            if (this.data[i][this.combineField.name] !== null) {
              let tem = this.pos.pop()
              this.pos.push([tem[0], [...tem[1], this.data[i][this.combineField.name]]])
            }
            count++ // 多一行合并
          } else {
            this.curAllKeysItems.push(this.data[i])
            this.spanArr.push([count, 1])
            this.pos.push([i, [this.data[i][this.combineField.name]]])
            count = 1
          }
        }
      }
      // console.log('pos:', this.pos)
      this.spanArr.push([count, 1])
      // 根据前一页状态给当前页状态赋值
      this.curAllKeysItems.forEach(item => {
        this.preAllInterviewerIdsStatus.forEach(i => {
          if (item[this.combineField.concat] == i[this.combineField.concat]) {
            if(i.checked == true) {
              this.selectionChangeFlag =true
              this.$nextTick(() => {
                this.$refs.tableRef.toggleRowSelection(item,true);
                this.selectAll(this.selected)
              })
            } else {
              this.selectionChangeFlag =true
              this.$nextTick(() => {
                this.$refs.tableRef.toggleRowSelection(item,false);
                this.selectAll(this.selected)
              })
            }
          }
        })
      })
    },
    // 合并表格方法
    spanMethod({ row, column, rowIndex, columnIndex }) {
      // console.log('row: ', row.executorName);
      if (columnIndex === 0 || columnIndex === 1 || columnIndex === 2 || columnIndex === 3) {
        if (rowIndex === this.pos[index][0]) {
          // let set = new Set(this.pos[index][1].filter(item => item !== ''));
          // if(set.size) {
          //   row.equalName = Array.from(set).join('、');
          // } else {
          //   row.equalName = '';
          // }
          if (columnIndex === 3) {
            return this.spanArr[index++]
          }
          return this.spanArr[index]
        } else {
          return [0, 0]
        }
      }
      index = index % this.pos.length
    },
    //保存当前选中页全部行的选中状态
    savePreAllInterviewerIdsStatus() {
      let array = []
      this.curAllKeysItems.forEach(i => {
        let flag = false
        this.selected.forEach(val => {
          if (
            val[this.combineField.concat] == i[this.combineField.concat] &&
            val[this.combineField.id] == i[this.combineField.id]
          ) {
            flag = true
            array.push({
              [this.combineField.concat]: i[this.combineField.concat],
              checked: true
            })
          }
        })
        if (flag == false) {
          array.push({
            [this.combineField.concat]: i[this.combineField.concat],
            checked: false
          })
        }
      })
      this.preAllInterviewerIdsStatus = array
    }
  },
  created() {
    this.getAnswerInterviewers()
    this.init()
  }
}
